<template>
    <MainContent 
        :title="`Mostrar boletín ${boletin ? boletin.id + ' - ' + boletin.asunto : '...'}`"
    >
        <template #header>
            <h4>{{ boletin?.asunto }}</h4>
            <div class="centrarBotones">
                <OpcionesDropdownComponent
                    :options="[
                        { to: { name: 'back.emails.boletines.enviar', params: { boletin_id: id } }, label: 'Enviar boletin' },
                    ]"
                />

                <button class="btn btn-primary" @click="activarInformeSpam">
                    {{ mostrarSpam ? 'Ocultar spam' : 'Comprobar spam' }}
                </button>
            </div> 
            
        </template>
        <template v-slot:content>
            <b-overlay :show="loading" rounded="sm">
                <div class="row" v-if="mostrarSpam">
                    <InformeSpam 
                        :comunicado="id"
                    />
                </div>
                <div v-if="boletin" class="row">
                    <div class="col-md-6">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered">
                                <tbody>
                                    <tr>
                                        <th class="bg-light text-right" width="30%">ID</th>
                                        <td class="">{{ boletin.id }}</td>
                                    </tr>
                                    <tr>
                                        <th class="bg-light text-right">Asunto</th>
                                        <td>{{ boletin.asunto }}</td>
                                    </tr>
                                    <tr>
                                        <th class="bg-light text-right">Remitente</th>
                                        <td>{{ boletin.remitente?.nombre || "No definido" }}</td>
                                    </tr>
                                    <tr>
                                        <th class="bg-light text-right">Responder a</th>
                                        <td>{{ boletin.responder_a || "No definido" }}</td>
                                    </tr>
                                    <tr>
                                        <th class="bg-light text-right">Carpeta de boletín</th>
                                        <td>
                                            {{ boletin.carpetas_comunicados?.[0]?.nombre || "Sin carpeta" }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="bg-light text-right">Grupos</th>
                                        <td>
                                            <span v-if="boletin.grupos && boletin.grupos.length">
                                                <template v-for="(grupo, index) in boletin.grupos">
                                                    <span :key="grupo.id">{{ grupo.nombre }}</span>
                                                    <span v-if="index < boletin.grupos.length - 1" :key="'comma-' + index">,</span>
                                                </template>
                                            </span>
                                            <span v-else>No hay grupos asignados</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered">
                                <tbody>
                                    <tr>
                                        <th class="bg-light text-right" width="30%">Creado en</th>
                                        <td>{{ boletin.created_at || "No disponible" }}</td>
                                    </tr>
                                    <tr>
                                        <th class="bg-light text-right">Actualizado en</th>
                                        <td>{{ boletin.updated_at || "No disponible" }}</td>
                                    </tr>
                                    <tr>
                                        <th class="bg-light text-right">Último envío en</th>
                                        <td>{{ boletin.fecha_ultimo_envio || "No enviado" }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="col-12 mt-4">
                        <div >
                            <Resumen 
                                :datos-resumen="datosResumen"
                                :loading="loadingResumen"
                                @date-range-changed="onResumenDateRangeChange"
                            />
                        </div>
                    </div>

                    <div class="col-12 mt-4">
                        <div >
                            <EstadisticasGenerales 
                                :datos-estadisticas="estadisticasGenerales"
                                :loading="loading"
                                @date-range-changed="onDateRangeChange"
                            />
                        </div>
                    </div>

                    <div class="col-12 mt-4">
                        <div >
                            <ActividadReciente 
                                :datos-actividad = "datosActividad"
                                :loading = "loadingActividad"
                                :boletin ="boletin"
                            />
                        </div>
                    </div>

                    <div class="col-12 mt-4">
                        <TabsOnlyComponent 
                            :tabs="[
                                { tab: 'previsualizar', nombre: 'Previsualizar' },
                                { tab: 'html', nombre: 'HTML' },
                            ]" 
                            :initialTab="contentTab" @selectTab="(newTab) => { contentTab = newTab; }"
                        >
                            <template v-slot:previsualizar>
                                <div class="content-preview p-3">
                                    <div v-html="boletin.contenido"></div>
                                </div>
                            </template>
                            <template v-slot:html>
                                <pre class="p-3 border rounded bg-light"><code>{{ boletin.contenido }}</code></pre>
                            </template>
                        </TabsOnlyComponent>
                    </div>
                </div>
                <div v-else-if="!loading">
                    <div class="alert alert-warning">
                        No se ha podido cargar la información del boletín.
                    </div>
                </div>
            </b-overlay>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import apiService from "@/services/api-comunicados";
    import TabsOnlyComponent from "../../../../components/backend/components/TabsOnlyComponent.vue";
    import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent.vue";
    import InformeSpam from "./InformeSpam.vue";
    import EstadisticasGenerales from "@/components/backend/components/dashboardComponents/EstadisticasGenerales.vue";
    import Resumen from "@/components/backend/campana-emails/dashboard/Resumen";
    import ActividadReciente from "@/components/backend/campana-emails/dashboard/ActividadReciente.vue";

    export default {
        props: {
            id: {
                type: [String, Number],
                required: true,
            }
        },
        components: {
            MainContent,
            TabsOnlyComponent,
            OpcionesDropdownComponent,
            InformeSpam,
            EstadisticasGenerales,
            Resumen,
            ActividadReciente
        },
        data() {
            return {
                tab: "mostrarBoletín",
                contentTab: "previsualizar",
                boletin: null,
                loading: false,
                loadingResumen: false,
                loadingActividad: false,
                mostrarSpam: false,
                estadisticasGenerales: {},
                datosResumen: {},
                datosActividad: [],
                fechaInicio: null,
                fechaFin: null,
                initialMount : true,
            };
        },
        created() {

            this.cargarBoletin(this.id);
        },
        methods: {
            async cargarBoletin(id) {
                this.loading = true;
                try {
                    const response = await apiService.getBoletin(id);
                    this.boletin = response.data;

                    await this.getEstadisticasGenerales();
                    await this.getResumenBoletin();
                    await this.getActividadRecienteBoletin();
                } catch (error) {
                    this.$toast.error("Error al cargar el boletín:", error);
                } finally {
                    this.loading = false;
                }
            },

            async getEstadisticasGenerales()
            {
                try {
                    this.loading = true;

                    const fechas = {
                        fecha_inicio: this.fechaInicio,
                        fecha_fin: this.fechaFin,
                    };

                    const  response = await apiService.getEstadisticasGeneralesBoletin(this.id, fechas);
                    this.estadisticasGenerales = { data: response.data || {} };
                } catch (error) {
                    this.$toast.error("Error al cargar las estadísticas generales.");
                }finally{
                    this.loading = false;
                }
            },

            async getResumenBoletin() {
                try {
                    this.loadingResumen = true;

                    const fechas = {
                        fecha_inicio: this.fechaInicio,
                        fecha_fin: this.fechaFin,
                    };

                    const  response = await apiService.getResumenBoletin(this.id, fechas);
                    this.datosResumen =  response.data;
                } catch (error) {
                    this.$toast.error("Error al cargar las estadísticas generales.");
                }finally{
                    this.loadingResumen = false;
                }
            },

            async getActividadRecienteBoletin(){
                try {
                    this.loadingActividad = true;

                    const response = await apiService.getActividadRecienteBoletin(this.id);
                    this.datosActividad = response.data || [];
                } catch (error) {
                    this.$toast.error("Error al cargar actividad reciente.");
                }
                finally {
                    this.loadingActividad = false;
                    this.initialMount = false;
                }
            },

            async onDateRangeChange({ startDate, endDate }) {
                if (this.initialMount) return;

                this.fechaInicio = startDate;
                this.fechaFin = endDate;
                await this.getEstadisticasGenerales();
            },

            async onResumenDateRangeChange({ startDate, endDate }) {
                if (this.initialMount) return;

                this.fechaInicio = startDate;
                this.fechaFin = endDate;
                await this.getResumenBoletin();
            },

            activarInformeSpam(){
                this.mostrarSpam = !this.mostrarSpam;
            }
        },
    };
</script>

<style scoped>
.table td {
    font-size: 1rem;
    text-transform: none;
}

.table th {
    width: 20%;
    background-color: #f8f9fa;
    font-weight: 500;
    text-transform: none;
}

.table-bordered tbody tr:last-child td,
.table-bordered tbody tr:last-child th {
    border-bottom: 1px solid #dee2e6;
}

.centrarBotones {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
}
</style>
